exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".person-fields .decoy{position:absolute;top:-100px}", ""]);

// exports
